import { Card, Group, Text, ThemeIcon } from "@mantine/core";
import React from "react";

export default function AnalyticsMetricCard({
  label,
  value,
  hint,
  icon,
}: {
  label: string;
  value: string;
  hint?: string;
  icon?: React.ReactNode;
}) {
  return (
    <Card withBorder h="100%">
      <Group position="apart" align="flex-start" noWrap>
        <div style={{ flex: 1 }}>
          <Text size="sm" c="dimmed">
            {label}
          </Text>
          <Text size="xl" fw={700} mt={4}>
            {value}
          </Text>
          {hint ? (
            <Text size="xs" c="dimmed" mt={8}>
              {hint}
            </Text>
          ) : null}
        </div>
        {icon ? (
          <ThemeIcon radius="md" size="lg" variant="light" color="blue">
            {icon}
          </ThemeIcon>
        ) : null}
      </Group>
    </Card>
  );
}